const CropGrid = () => {
    return (
        <div className="m-crop-grid point-event-none">
            <div
                className="m-crop-grid__line horizontal point-event-none"
                style={{
                    top: '33.33%',
                }}
            />
            <div
                className="m-crop-grid__line horizontal point-event-none "
                style={{
                    top: '66.66%',
                }}
            />

            <div
                className="m-crop-grid__line vertical point-event-none"
                style={{
                    left: '33.33%',
                }}
            />

            <div
                className="m-crop-grid__line vertical point-event-none "
                style={{
                    left: '66.66%',
                }}
            />
        </div>
    );
};

export default CropGrid;
